module.exports = __webpack_public_path__ + "static/media/github-workflow-inputs.bd61b84b.png";